<ng-container *ngIf="!loading">
  <div class="logs">
    <div class="log-btns">
      <div class="block-btn" *ngFor="let block of blockTitles; let i = index" [ngClass]="block === selectedBlock ? 'active' : ''"
        (click)="selectBlock(block)">
        {{block}}
      </div>
    </div>
    <div class="history">
      <div class="years">
        <div class="yearBtn to-left" (click)="selectPrev()"> <span>❮</span></div>
        <div class="year" *ngFor="let year of years; let i = index" (click)="selectYear(year)" [ngClass]="[year === selectedYear ? 'active' : '', 'year-'+i]">
          {{year}}
        </div>
        <div class="yearBtn to-right" (click)="selectNext()"> <span>❯</span> </div>
      </div>
      <table class="fixed_headers">
        <thead>
          <tr>
            <th class="param">Параметр</th>
            <th class="mio">МИО</th>
            <th class="user">Пользователь</th>
            <th class="value">Значение</th>
            <th class="act">Действие</th>
            <th class="date">Время редактирования</th>
          </tr>
        </thead>
        <div class="tbody">
          <tbody *ngFor="let log of data">
              <tr class="first-tr">
                <td [attr.rowspan]="log.dataArr.length" class="first-td"> {{log.columnTitle}} </td>
                <td class="mio">{{log.dataArr[0].userMIOTitle}}</td>
                <td class="user">{{log.dataArr[0].userName}}</td>
                <!-- <td class="value" *ngIf="log.dataArr[0].isFile == true"> <a class="link"  (click)="downloadDocument(log.dataArr[0].dbFileID, log.dataArr[0].value)">{{log.dataArr[0].value}}</a> </td> -->
                <td class="value" *ngIf="log.dataArr[0].isFile == true"> 
                  <a 
                    [downloadFile]="api+'Files/DownloadDocument?fileID='+log.dataArr[0].dbFileID"
                    [filename]="log.dataArr[0].value"
                    class="filename">
                      {{log.dataArr[0].value}}
                  </a> 
                </td>

                <td class="value" *ngIf="log.dataArr[0].isFile == false"> <span *ngIf="log.dataArr[0].columnTitle == 'Фото ЖК'">ID:</span> {{log.dataArr[0].value}} </td>
                <td class="act">{{getActionTitle(log.dataArr[0].operType)}}</td>
                <td class="date">{{log.dataArr[0].updatedOn | date: 'dd.MM.yyyy HH:mm'}}</td>
              </tr>
              <tr *ngFor="let d of log.dataArr.slice(1, log.dataArr.length)">
                <td class="mio">{{d.userMIOTitle}}</td>
                <td class="user">{{d.userName}}</td>
                <!-- <td class="value" *ngIf="d.isFile == true"> <a class="link"  (click)="downloadDocument(log.dataArr[0].dbFileID, log.dataArr[0].value)">{{d.value}}</a> </td> -->
                <td class="value" *ngIf="d.isFile == true"> 
                  <a  
                    [downloadFile]="api+'Files/DownloadDocument?fileID='+d.dbFileID"
                    [filename]="d.value"
                    class="filename">
                      {{d.value}}
                  </a>
                </td>

                <td class="value" *ngIf="d.isFile == false"> <span *ngIf="d.columnTitle == 'Фото ЖК'">ID:</span> {{d.value}} </td>
                <td class="act">{{getActionTitle(d.operType)}}</td>
                <td class="date">{{d.updatedOn | date: 'dd.MM.yyyy HH:mm'}}</td>
              </tr>
          </tbody>
        </div>
      </table>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="loading">
  <div class="loading"></div>
</ng-container>
